import { defineStore } from 'pinia';

export const useResetPasswordStore = defineStore('resetPassword', () => {
    const resetPasswordEmail = ref('');

    return {
        resetPasswordEmail,
    };
});
